import styled from 'styled-components';

// prevent layout overflow due to long values
export const ItemWrapper = styled.div`
  min-width: 0;
`;
